import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import Dropdown from 'components/ReusableComponents/ManageHotel/Dropdown'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import moment from 'moment'
import { useEffect, useState } from 'react'
import subsidiariesApi from 'services/api/subsidiaries'

import { USCurrency } from '../../../components/ReusableComponents/FormattedPrice/index'
import Box from '../Box/index'
import styles from './Services.module.scss'

const AddPeriodDialog = ({ onSave, onClose, nearestStartDate }) => {
  const [rate, setRate] = useState()
  const [period, setPeriod] = useState()

  function handleSave() {
    subsidiariesApi.prepayPeriod
      .post({
        period,
        rate: Number(rate)
      })
      .then(() => {
        onSave()
      })
  }

  return (
    <ConfirmationDialog
      title="Add payment period"
      theme="blacklist"
      onClose={onClose}
      onConfirm={handleSave}
      isButtonDisabled={!(rate && period)}
      positiveMessage="Add payment period"
      negativeMessage="Cancel"
    >
      <div className={styles.updateInputsHolder}>
        <TextInput
          type="date"
          label="Payment period will start on"
          value={moment(nearestStartDate).format('YYYY-MM-DD')}
          disabled
        />
        <Dropdown
          type="select"
          label="Period"
          options={{ Monthly: 'Monthly', Quarterly: 'Quarterly', Annual: 'Annual' }}
          value={period}
          defaultVal="Select period"
          onChange={e => setPeriod(e.target.value)}
        />
        <TextInput
          type="number"
          label="Rate (USD / month)"
          value={rate}
          onChangeValue={setRate}
        />
      </div>
    </ConfirmationDialog>
  )
}

const PrepayPreferences = ({ onSave }) => {
  const [showAddDialog, setShowAddDialog] = useState()

  const [activePeriod, setActivePeriod] = useState()
  const [nextPeriod, setNextPeriod] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const [nearestStartDate, setNearestStartDate] = useState()

  const [isNotPrepay, setIsNotPrepay] = useState(false)

  useEffect(() => {
    subsidiariesApi.prepayPeriod
      .get()
      .then(res => {
        setActivePeriod(res.activePeriod)
        setNextPeriod(res.nextPeriod)
        setNearestStartDate(res.nearestStartDate)
        setIsLoading(false)
      })
      .catch(() => {
        setIsNotPrepay(true)
        setIsLoading(false)
      })
  }, [])

  function handleSaveNewPeriod() {
    onSave()
    setShowAddDialog(false)
  }

  if (isLoading) {
    return <LoadingIndicator />
  }

  if (isNotPrepay) {
    return null
  }

  return (
    <Box
      title="Prepay preferences"
      hasCornerButton={true}
      onClickCornerButton={() => setShowAddDialog(true)}
    >
      {showAddDialog && (
        <AddPeriodDialog
          onClose={() => setShowAddDialog(false)}
          onSave={handleSaveNewPeriod}
          nearestStartDate={nearestStartDate}
          paymentPeriod={activePeriod}
        />
      )}
      <div className={styles.row}>
        <div>
          <span className={styles.planName}>{activePeriod.period} payments</span>
          <p className={styles.startDate}>
            <span className={styles.active}>Started</span> on{' '}
            {moment(activePeriod.startDate).format('MMM D, YYYY')}
          </p>
        </div>
        <span className={styles.planRate}>
          <USCurrency>{activePeriod.rate}</USCurrency>
        </span>
      </div>
      {nextPeriod && (
        <div className={styles.row}>
          <div>
            <span className={styles.planName}>{nextPeriod.period} payments</span>
            <p className={styles.startDate}>
              <span className={styles.next}>Will start</span> on{' '}
              {moment(nextPeriod.startDate).format('MMM D, YYYY')}
            </p>
          </div>
          <span className={styles.planRate}>
            <USCurrency>{nextPeriod.rate}</USCurrency>
          </span>
        </div>
      )}
    </Box>
  )
}

export default PrepayPreferences
